var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Link } from 'react-router-dom';
import InputError from '@/container/Ui/Common/InputError';
import PlainInput from '@/container/Ui/Common/PlainInput';
import { propShape } from '@/helpers/custom-prop-types';
import { termsPath, privacyPath } from '@/utils/router/links';
const FieldAssign = (props) => {
    const { input, meta } = props;
    const { value } = input, otherInput = __rest(input, ["value"]);
    return (_jsxs("div", Object.assign({ className: 'field' }, { children: [_jsx("div", { children: _jsxs("label", Object.assign({ className: 'pointer' }, { children: [_jsxs("div", Object.assign({ className: 'checkbox_wrapper' }, { children: [_jsx(PlainInput, { className: '', defaultValue: value, input: otherInput, meta: meta, type: 'checkbox' }), _jsx("i", {})] })), _jsxs("span", { children: [_jsx(Link, Object.assign({ target: '_blank', to: termsPath() }, { children: "\u5229\u7528\u898F\u7D04" })), "\u3001", _jsx(Link, Object.assign({ target: '_blank', to: privacyPath() }, { children: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC" })), "\u306B\u540C\u610F\u3057\u307E\u3059"] })] })) }), _jsx(InputError, { meta: meta })] })));
};
FieldAssign.propTypes = {
    input: propShape().isRequired,
    meta: propShape().isRequired,
};
export default FieldAssign;
